import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const data_sync_configuration_complete: EventDefinition = {
  getData: (_, eventData = {}) => ({
    ...pick(eventData, ['fieldsChanged', 'firstTimeSetup']),
  }),
  addContexts: ({ eventData } = {}) =>
    createContexts(['integration'], {
      eventData: {
        integration: { slug: eventData?.slug },
      },
    }),
};
